import { CancellablePromise } from './cancellable-promise'

export const cancellableFetch = (url, options) => {
    const controller = new AbortController()
    const { signal } = controller
    const requestOptions = {
        ...options,
        signal,
    }

    return CancellablePromise(fetch(url, requestOptions), controller)
}
